/** Maps pathname → header title (exact paths after trimming trailing slashes). */
const ADMIN_PAGE_TITLES: Record<string, string> = {
  "/": "Sign in",
  "/signup": "Admin signup",
  "/dashboard": "Dashboard",
  "/profile": "User profile",
  "/change-password": "Change password",
  "/users/update-download-count": "Update download counts",
  "/users/update-data": "Update users data",
  "/users/registration": "User registration",
  "/users/search-history": "User search history",
  "/users/download": "User downloads",
  "/users/export": "Export users",
  "/users/merge-data": "Merge data",
  "/export-elibrary": "Export e-library",
  "/export-book": "Export books",
  "/export-article": "Export articles",
  "/export-magazine": "Export magazines",
  "/export-agam": "Export Agam",
  "/export-manuscript": "Export manuscripts",
  "/export-audio": "Export audio",
  "/data-analysis/global-search": "Global search",
  "/data-analysis/misspelled-word": "Misspelled words",
  "/data-analysis/synonym-word": "Synonym words",
  "/data-analysis/reference-book": "Reference book",
  "/shopping-cart/manage-stock-india": "Manage stock — India",
  "/shopping-cart/manage-stock-usa": "Manage stock — USA",
  "/shopping-cart/manage-stock-special-usa": "Manage stock — Special USA",
  "/shopping-cart/manage-stock-other": "Manage stock — other regions",
  "/shopping-cart/manage-address": "Ordering addresses",
  "/shopping-cart/order-management": "Order management",
  "/shopping-cart/purchase-orders": "Purchase orders",
  "/shopping-cart/shipping-management": "Shipping management",
  "/content/about-us": "About us",
  "/content/committee": "Committee",
  "/content/contact": "Contact us",
  "/content/donate": "Donate page",
  "/content/terms": "Terms",
  "/content/privacy-policy": "Privacy policy",
  "/content/banner": "Home banners",
  "/content/home-hero": "Home hero",
  "/content/footer": "Footer",
  "/content/featured-books": "Featured books",
};

export function getAdminPageTitle(pathname: string): string {
  const key = pathname.replace(/\/+$/, "") || "/";
  return ADMIN_PAGE_TITLES[key] ?? "Admin portal";
}
